import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAbandonedProductPlaceholder = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 320,
	height: 116,
	viewBox: "0 0 320 116",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fill: "#F4F9FC",
				d: "M320 13.694C320 6.131 312.389 0 303 0H17C7.611 0 0 6.131 0 13.694v88.612C0 109.869 7.611 116 17 116h286c9.389 0 17-6.131 17-13.694V13.694z"
			}),
			/* @__PURE__ */ _jsx("text", {
				fill: "#2C3541",
				fontFamily: "Larsseit-Light, Larsseit",
				fontSize: 14,
				fontWeight: 300,
				children: /* @__PURE__ */ _jsx("tspan", {
					x: 101,
					y: 84,
					children: "Your Product Image"
				})
			}),
			/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
				d: "M0 0L32 0 32 32 0 32z",
				transform: "translate(144 26)"
			}), /* @__PURE__ */ _jsx("path", {
				fill: "#B7C3CD",
				fillRule: "nonzero",
				d: "M28.547 15.44l-12-12c-.48-.48-1.147-.773-1.88-.773H5.333c-1.466 0-2.666 1.2-2.666 2.666v9.334c0 .733.293 1.4.786 1.893l12 12c.48.48 1.147.773 1.88.773.734 0 1.4-.293 1.88-.786l9.334-9.334c.493-.48.786-1.146.786-1.88 0-.733-.306-1.413-.786-1.893zM7.333 9.333c-1.106 0-2-.893-2-2 0-1.106.894-2 2-2 1.107 0 2 .894 2 2 0 1.107-.893 2-2 2z",
				transform: "translate(144 26)"
			})] })
		]
	})
});
export default SvgAbandonedProductPlaceholder;
